<template>
	<div>

<div class="uk-container-expand postScreen">
<appNav></appNav>
</div>


	<div class="uk-container postScreen">

		<!-- <div class="uk-h3">{{ ms }}</div> -->
		<hr class="uk-divider-icon">

    <div class="uk-grid-large" uk-grid>

					<div class="uk-width-auto rightBorder uk-visible@s">
							<div class="leftNavBar">
								<appOurShops></appOurShops>
							</div>
							
					</div>

					<div class="uk-width-expand">

								<article class="uk-article">
										<div class="uk-h2"><a class="uk-link-reset" href="">{{ post.title }}</a></div>
										<p class="uk-article-meta">{{ post.author }}</p>
										<div class="uk-cover-container uk-width-2-3">
											<img :src="post.picPost" alt="" uk-cover />
											<canvas width="500" height="400"></canvas>
										</div>
										<p class="shortDescr uk-text-lead">{{ post.shortDescr }}</p>
										<p class="descr" v-html="post.descr"></p>
										<div class="uk-grid-small uk-child-width-auto" uk-grid>
												<div>
													<button @click="goBlog" class="uk-button uk-button-text">Назад</button>
												</div>
												<div>
													<button @click="goShop" class="whereBuy uk-button uk-button-text">Где купить <i class="mdi mdi-cart-outline"></i></button>
												</div>
										</div>
								</article>
					</div>
			</div>
			</div>

<br>
<br>
<br>
			</div>
</template>



<script>
import appNav from '@/components/Nav'
import appOurShops from '@/components/Ourshops'

export default {
	props: ['id'],
	data () {
		return {
			ms: 'Отдельная запись'
		}
	},
	methods: {
		goBlog () {
			this.$router.push('/blog')
		},
		goShop () {
			this.$router.push('/shops')
		}
	},
	computed: {
		post () {
			let id = this.id
			return this.$store.getters.postById(id)
		}
	},
	created() {
			window.scrollTo(0, 0);
		},
	components: {
		appNav,
		appOurShops
	}
}
</script>


<style>

/* @import url(/uikit/css/uikit.min.css); */

.postScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.postScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}

.postScreen .leftNavBar{
 width: 200px;
 padding-right: 5px;
 /* background-color: #ccc; */
}

.shortDescr {
	font-size: 18px;
}

.whereBuy{
	color:#DE1F24;
	font-weight: 500;
}



</style>